
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftLeft25 as ObiThreewayAcuatorPistonInleftLeft25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-left-25.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftLeft25 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-left-25',
   elementClass: ObiThreewayAcuatorPistonInleftLeft25Element,
   events: {
     
   }
  });
 
 